import gql from 'graphql-tag'

const customAttributeTypes = gql`
  query customAttributeDataTypes {
    customAttributeDataTypes {
      id
      name
    }
  }
`

export default customAttributeTypes
